import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import { MY_PLAYLISTS_TABS, getMyPlaylistsUrl, useMyPlaylistsParams } from '..';
import I18n from 'I18n';
import useNavigate from '../../../hooks/useNavigate';
import styled, { css, theme, mediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const MyPlaylistsTab = styled(UITab).withConfig({
  displayName: "MyPlaylistsTabNavigation__MyPlaylistsTab",
  componentId: "jbi6c6-0"
})(["", ""], ({
  $archived
}) => $archived === 1 ? mediaQuery('notLaptop', css(["display:flex;margin-left:64px;&::before{content:'';display:block;width:1px;height:100%;background-color:", ";transform:translateX(-56px);}"], theme.colors.BATTLESHIP)) : null);
export const MyPlaylistsTabNavigation = () => {
  const navigate = useNavigate();
  const {
    tab: selectedTab
  } = useMyPlaylistsParams();
  return /*#__PURE__*/_jsx(UITabs, {
    className: "m-bottom-5",
    selected: selectedTab,
    children: MY_PLAYLISTS_TABS.map(tab => /*#__PURE__*/_jsx(MyPlaylistsTab, {
      $archived: tab === 'archived' ? 1 : 0,
      onClick: () => navigate(getMyPlaylistsUrl({
        tab
      })),
      tabId: tab,
      title: I18n.text(`learningCenter.topFilters.myPlaylistsType.${tab}`)
    }, `my-playlists-nav_${tab}`))
  });
};